// Comment categories shared across pages
import { Sparkles, ThumbsUp, Minus, ThumbsDown, AlertOctagon, Siren } from "lucide-react";

export const CATEGORY_META = {
    very_good: { label: "Shumë mirë", color: "bg-sage text-white border-sage", icon: Sparkles, score: 2 },
    good: { label: "Mirë", color: "bg-seablue text-white border-seablue", icon: ThumbsUp, score: 1 },
    neutral: { label: "Neutral", color: "bg-slate-200 text-slate-700 border-slate-300", icon: Minus, score: 0 },
    bad: { label: "Keq", color: "bg-orange-400 text-white border-orange-500", icon: ThumbsDown, score: -1 },
    very_bad: { label: "Shumë keq", color: "bg-terracotta text-white border-terracotta", icon: AlertOctagon, score: -2 },
    warning: { label: "Vërejtje shumë e keqe", color: "bg-red-700 text-white border-red-800", icon: Siren, score: -3 },
};

export const CATEGORY_KEYS = ["very_good", "good", "neutral", "bad", "very_bad", "warning"];

export const CategoryChip = ({ category, testId }) => {
    const m = CATEGORY_META[category];
    if (!m) return null;
    const Icon = m.icon;
    return (
        <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full border text-[11px] font-bold ${m.color}`} data-testid={testId}>
            <Icon className="w-3 h-3" /> {m.label}
        </span>
    );
};
